import { PermissionedRoutes } from "@components/PermissionedRoutes";
import { Navigate, RouteObject } from "react-router-dom";
import { ValidatedRoutes } from "@components/PermissionedRoutes";

const DEPOSIT_APPLICATION_ROUTES: RouteObject[] = [
  {
    index: true,
    async lazy() {
      const { ApplicationsList } = await import("./deposits/application_list/ApplicationsList");
      return {
        Component() {
          return <ApplicationsList />;
        },
      };
    },
  },
  {
    path: "ai_search",
    element: (
      <ValidatedRoutes
        validate={(userConfiguration) => {
          const { isFeatureEnabled, permissions } = userConfiguration;
          return (
            isFeatureEnabled("command_ai_search", "deposit_applications") &&
            permissions.includes("backoffice.use_ai_search")
          );
        }}
      />
    ),
    children: [
      {
        index: true,
        async lazy() {
          const { AiSearch } = await import("./deposits/ai_search/AiSearch");
          return { element: <AiSearch /> };
        },
      },
      {
        path: ":threadId",
        async lazy() {
          const { ApplicationsAiThread } = await import("./deposits/ai_search/AiThread");
          return { element: <ApplicationsAiThread /> };
        },
      },
    ],
  },
  {
    element: (
      <PermissionedRoutes requiredPermissions={["backoffice.manage_applicant_information"]} />
    ),
    children: [
      {
        path: ":applicationId/application_change_state",
        async lazy() {
          const { ApplicationChangeStatePage } = await import(
            "../application_change_state/ApplicationChangeStatePage"
          );
          return { element: <ApplicationChangeStatePage /> };
        },
      },
    ],
  },
  {
    element: (
      <PermissionedRoutes requiredPermissions={["backoffice.manage_applicant_information"]} />
    ),
    children: [
      {
        path: ":applicationId/edit",
        async lazy() {
          const { EditApplication } = await import("./deposits/edit_application/EditApplication");
          return { element: <EditApplication /> };
        },
      },
    ],
  },
  {
    element: (
      <PermissionedRoutes
        requiredPermissions={["backoffice.manage_applicant_information"]}
        requiredFeatures={["edit_bao_applications"]}
      />
    ),
    children: [
      {
        path: ":applicationId/editbusiness",
        async lazy() {
          const { EditBusinessApplication } = await import(
            "./deposits/edit_application/EditBusinessApplication"
          );
          return { element: <EditBusinessApplication /> };
        },
      },
    ],
  },
];

const LOAN_APPLICATION_ROUTES: RouteObject[] = [
  {
    index: true,
    async lazy() {
      const { Applications } = await import("./loans/Applications");
      return {
        Component() {
          return <Applications />;
        },
      };
    },
  },
];

export const APPLICATION_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <Navigate to="deposits" />,
  },
  {
    path: "deposits",
    children: DEPOSIT_APPLICATION_ROUTES,
  },
  {
    path: "loans",
    element: (
      <ValidatedRoutes
        validate={(userConfiguration) => {
          const { permissions, features } = userConfiguration;
          if (!features.includes("lending")) {
            return false;
          }
          return (
            permissions.includes("lending_api.view_personalloanapplication") ||
            permissions.includes("lending_api.view_creditcardapplication")
          );
        }}
      />
    ),
    children: LOAN_APPLICATION_ROUTES,
  },
  {
    path: "membership_card_uploads",
    element: <PermissionedRoutes requiredRoles={["narmi"]} />,
    children: [
      {
        index: true,
        async lazy() {
          const { MembershipCardUploadRuns } = await import(
            "./membership_card_uploads/MembershipCardUploadRuns"
          );
          return { element: <MembershipCardUploadRuns /> };
        },
      },
    ],
  },
];
